export default "__VITE_ASSET__CDYebZWO__"